<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box form-inline">
          <div class="box-body">
            <div class="row">
              <div class="col-sm-6 text-left">
                <div class="form-group text-left">
                  <router-link :to="{path: '/crPrinter'}">
                    <div class="btn btn-default btn-table-title">新增出單機</div>
                  </router-link>
                </div>
              </div>
              <div class="col-sm-6 text-right">
                <div class="form-group">
                  <select class="form-control h-38">
                    <option value="1">辨識碼</option>
                  </select>
                </div>
                <div class="form-group search-bar">
                  <div class="input-group">
                    <input class="form-control" type="text" v-model="searchResult">
                    <span class="input-group-addon c-pointer" @click="clickPage(1)"><i class="fa fa-search"></i></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">出單機名稱(ID)</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">類型</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">辨識碼</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">啟用</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                  </tr>
                  </thead>
                  <tbody v-if="isLoading">
                    <tr>
                      <td colspan="12" class="text-center">資料讀取中......</td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="printerList.length === 0">
                    <tr style="background-color: white">
                      <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                        <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                        <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="printerList.length > 0">
                  <tr class="even" role="row" v-for="(printer, index) in printerList">
                    <!-- cloumn 0 -->
                    <td class="sorting_1">{{index + 1}}</td>
                    <td>
                      <router-link :to="'/printerInfo/' + printer.printer_id">出單機{{printer.printer_id}}號 ({{printer.printer_id}})</router-link>
                    </td>
                    <td>{{printer.printer_type}}</td>
                    <td>{{printer.printer_identity}}</td>
                    <td>
                      <span v-if="printer.printer_is_enabled" class="label label-success">啟用</span>
                      <span v-if="!printer.printer_is_enabled"  class="label label-danger">未啟用</span>
                    </td>
                    <td>
                      <router-link :to="'upPrinter/' + printer.printer_id">
                        <button class="btn btn-default"><i class="fa fa-pencil"></i></button>
                      </router-link>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                        :groupAmount="groupAmount" :clickPage="clickPage" ref="brandPaginate"
              >
              </paginate>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import mqttTable from './Temp/MqttTableTemp.vue'
export default {
  name: 'Tables',
  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      searchResult: '',
      printerList: [],
      isLoading: true
    }
  },
  mounted () {
  },
  components: {
    'mqtt-table': mqttTable
  },
  methods: {
    printerType (type) {
      switch (type) {
        case 1: return '熒埔'
        case 2: return '飛鵝'
      }
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getPrinterList()
    },
    getPrinterList () {
      this.isLoading = true
      var self = this
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      var url = '/printer/list?page=' + data.page + '&size=' + data.size
      if (this.searchResult) url = url + '&identity=' + this.searchResult
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerList = response.data.list
          self.isLoading = false
          self.total = response.data.total
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    this.fixedH()
    this.getPrinterList()
  }
}
</script>



// WEBPACK FOOTER //
// PrinterTable.vue?4a1c4a3f